import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import '../components/Navbar.css';
import '../components/HeroCards.css';

function HomePage() {
  document.title = 'Florida Elections - Home';
  return (
    <div style={{ background: '#ffffff', minHeight: '100vh', color: '#000' }}>
      <Navbar />

  <main style={{ maxWidth: '1000px', margin: '8px auto', padding: '12px', paddingBottom: '88px' }}>
    <section style={{ padding: '14px', borderRadius: 12, boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
          {/* hero card styles are provided by ../components/HeroCards.css */}

          <div className="hero">
            <h2>Welcome to a better campaign finance database.</h2>
            <p style={{ fontSize: '1rem', color: 'rgba(0,0,0,0.78)' }}>Explore candidate and committee information for elections, past and present.</p>

            <div className="cards-container">
              <Link to="/candidates" className="card">
                <h3>Search All Candidates</h3>
                <p>Find candidates by year, office, district and see financial summaries and filed documents.</p>
              </Link>

              <Link to="/committees" className="card">
                <h3>Browse All Committees</h3>
                <p>View committee filings, financials, and filed documents.</p>
              </Link>

              <Link to="/documents/recent" className="card">
                <h3>Recent Documents</h3>
                <p>View the most recent 100 documents filed with the Division of Elections.</p>
              </Link>
            </div>
          </div>
        </section>
      </main>
      {/* Disclaimer footer: fixed on larger screens, static on small screens */}
      <style>{`
        .fe-footer { position: fixed; left: 0; right: 0; bottom: 0; background-color: #000; color: #fff; padding: 16px; font-size: 0.85rem; margin-top: 24px; z-index: 999; }
        .fe-footer__inner { max-width: 1000px; margin: 0 auto; }

        /* On small screens make the footer flow with the document (not sticky) */
        @media (max-width: 720px) {
          .fe-footer { position: static; padding: 12px 10px; }
        }
      `}</style>

      <footer className="fe-footer">
        <div className="fe-footer__inner">
          Florida Elections is an independent site aggregating public data from the Florida Division of Elections for informational purposes only. It is not affiliated with, endorsed by, or sponsored by the Florida Division of Elections, State of Florida, or any government agency. Data is sourced from official records but may not reflect the latest updates—verify directly at dos.fl.gov/elections. We assume no liability for errors, omissions, or consequences from use of this information. This site provides no legal, financial, or professional advice.
        </div>
      </footer>
    </div>
  );
}

export default HomePage;